// extracted by mini-css-extract-plugin
export default {"rounded":"TextArea__rounded___IDzXa","container":"TextArea__container___Zd_Oq","charCount":"TextArea__charCount___LiH7y","charCountBelow":"TextArea__charCountBelow___drY5L"};